import { Observable, Observer } from 'rxjs';
import  { ToastrService } from 'ngx-toastr';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OktaAuth,
  AccessToken,
  IDToken,
  UserClaims,
  TokenParams,
  AuthApiError} from '@okta/okta-auth-js';
import { environment } from 'src/environments/environment';
import { Constants } from './../../assets/Constants';

@Injectable({ providedIn: 'root' })
export class OktaAuthService {

  CLIENT_ID = environment.oidc.clientId;
  ISSUER = environment.oidc.issuer;
  LOGIN_REDIRECT_URI = environment.oidc.redirectUri;
  LOGOUT_REDIRECT_URI = '/home';

  oktaAuth = new OktaAuth({
    clientId: this.CLIENT_ID,
    issuer: this.ISSUER,
    redirectUri: this.LOGIN_REDIRECT_URI,
    pkce: environment.oidc.pkce
  });
  
  $isAuthenticated: Observable<boolean>;
  private observer?: Observer<boolean>;
  private toaster!: ToastrService;
  constructor(private router: Router, private toastr:ToastrService ) {
    this.$isAuthenticated = new Observable((observer: Observer<boolean>) => {
      this.observer = observer;
      this.toaster = toastr;
      this.isAuthenticated().then(val => {
        observer.next(val);
      });
    });
  }

  async isAuthenticated() {
    // Checks if there is a current accessToken in the TokenManger.    
    return !!(await this.oktaAuth.tokenManager.get('accessToken'));
  }
  isUserAuthorized(role:string):boolean {  
    let token= this.oktaAuth.tokenManager.getTokensSync();
    let claims:any=token?.accessToken?.claims?.['Groups'];
    let groups:any=[];
    if(typeof claims=="string")
      {
        groups=[claims];
      }
      else
      {
        groups=claims;
      }
      //return true;
    let roles = role.split(",");
    let isAuthorized = (groups !='' && groups!=undefined && groups.some((group_role:any)=>roles.includes(group_role)));
    //if(groups!=undefined && (groups.includes("RXORDERS-VELA-ADMIN") || groups.includes(role)))
    if(groups !='' && groups!=undefined && (groups.includes("RXORDERS-VELA-ADMIN") || isAuthorized))
    {
      return true;
    }
  //   for (let role of groups) {
  //     let pages=Constants.roleMap[role]
  //     if((pages !=undefined) && (pages.includes(action)|| pages.includes("*")))
  //     {
  //       return true;
  //     }
      
  //  }
   return false;
  }
  async getUser(){
    const urlParams = new URLSearchParams(this.router.url);
    const errorName = urlParams.get('error');

    if (this.router.url !== '/logout') 
    if (await this.isAuthenticated() && (errorName == "" || errorName == undefined ||  errorName == null)) {
      return await this.oktaAuth.getUser().then(
        successResponse => {
        return successResponse.name!.toString();
      },
      failureResponse => {
        if(failureResponse instanceof AuthApiError) {
        this.toaster.warning("You have expired or wrong access token and it's requried re-authenticated. This page will be redirect to Okta Login Page in few seconds", 
          "Wrong Token",
          { 
            timeOut: 4000
          }).onHidden.subscribe(() => { 
            this.toastr.clear();
            this.login('/home');
          });
      }});
    }
    return '';
  }

  async revokeAccessToken() {
    this.oktaAuth.revokeRefreshToken();
    this.oktaAuth.revokeAccessToken();
    return this.oktaAuth.closeSession();
  }
  public getToken() {
    if (this.isAuthenticated()) {
      return this.oktaAuth.getAccessToken();
    }
    return '';
  }

  login(originalUrl: string) {
    // Save current URL before redirect
    sessionStorage.setItem('okta-app-url', originalUrl || this.router.url);

    // Launches the login redirect.
    this.oktaAuth.token.getWithRedirect({
      scopes: ['openid', 'email', 'profile']
    });
  }

  async handleAuthentication() {
    const tokenContainer = await this.oktaAuth.token.parseFromUrl();
    this.oktaAuth.tokenManager.add('idToken', tokenContainer.tokens.idToken as IDToken);
    this.oktaAuth.tokenManager.add('accessToken', tokenContainer.tokens.accessToken as AccessToken);
    
    if (await this.isAuthenticated()) {
      this.observer?.next(true);
    }

    // Retrieve the saved URL and navigate back
    const url = sessionStorage.getItem('okta-app-url') as string;
    this.router.navigateByUrl(url);
  }

  async logout() {
    await this.oktaAuth.signOut({
      postLogoutRedirectUri: this.LOGOUT_REDIRECT_URI
    });
  }

}
